/// <reference path="../../lib/app.d.ts" />

export interface Notification
{
	$item : JQuery,
	timeout : number
}

export class NotificationManager
{
	TAG = "[Sxc.Chat.NotificationManager]";

	private notifications : Array<Notification> = [];
	private currentNotification : Notification;
	private currentTimeout;

	public onClick : Function;
	public onOpen : Function;
	public onClose : Function;

	constructor(private $root)
	{

	}

	/**
	 * Adds a new Notification, and show it if it's possible.
	 */
	add($item : JQuery, timeout = null) : Notification
	{
		var notification = {
			$item: $item,
			timeout: timeout ? timeout : 1000,
		};

		this.$root.on("click", () => {
			if (this.onClick()) this.onClick();
			//this.clear();
		});

		//logging.log(this.TAG, "[add]", notification);

		this.notifications.push(notification);
		this.showNext();
		return notification;
	}

	/**
	 * Shows next Notification in the queue if it's possible (no other Notifications are visible)
	 */
	private showNext(fastSwap : boolean = false)
	{
		if (this.currentNotification) return;
		if (!this.notifications.length) return;

		this.currentNotification = this.notifications.shift();

		//logging.log(this.TAG, "[showNext]", this.currentNotification);

		if (fastSwap) this.$root.empty();
		this.$root.addClass("sxc-visible");
		this.$root.append(this.currentNotification.$item);
		if (this.onOpen()) this.onOpen();

		this.currentTimeout = setTimeout(() =>
		{
			if (!this.currentNotification) return;

			// Close method: If there is more notification in the queue just fast-swap
			// If not, do animation

			if (this.notifications.length)
			{
				this.$root.empty();
				this.currentNotification = null;
				if (this.onClose()) this.onClose();

				this.showNext(true);
			}
			else
			{
				this.$root.removeClass("sxc-visible");


				setTimeout(() =>
				{
					this.$root.empty();
					this.currentNotification = null;
					if (this.onClose()) this.onClose();
					this.showNext();
				}, 200);
			}

		}, this.currentNotification.timeout);


		// This timeout is for cancelling the current notification early in case there is a queue

		setTimeout(() =>
		{
			if (this.notifications.length)
			{
				clearTimeout(this.currentTimeout);
				this.$root.empty();
				this.currentNotification = null;
				this.showNext(true);
			}

		}, this.currentNotification.timeout / 2);
	}

	clear():void {
		this.notifications = [];
		this.$root.empty().removeClass("sxc-visible");
		this.currentNotification = null;
		clearTimeout(this.currentTimeout);
	}
}
